<template>
  <div class="big">
    <div class="page_title">短信模板</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div class="searchbox">
          <div>
            <el-input
              v-model="content"
              placeholder="请输入模板名称或短信内容"
              style="width: 300px; margin-right:10px"
              @change="search"
              clearable
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
            >查询</el-button>
          </div>
          <el-button
            type="primary"
            @click="AddTem"
            style="width: 120px"
            :disabled="module_id_array[0] ? !module_id_array.includes('1292') : false"
          >新建模板</el-button>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="模板名称"
              prop="sms_title"
            ></el-table-column>
            <el-table-column
              label="短信内容"
              prop="sms_content"
              width="800"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="editTem(scope.row)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1293') : false"
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="delTem(scope.row.tcm_id)"
                  :disabled="module_id_array[0] ? !module_id_array.includes('1294') : false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加模板弹窗 -->
    <el-dialog
      title="短信模板"
      :visible.sync="addtem"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="myform">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="模板名称"
            prop="sms_title"
          >
            <el-input
              style="width:450px"
              placeholder="请输入模板名称"
              v-model="ruleForm.sms_title"
              maxlength="10"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="短信内容"
            prop="sms_content"
          >
            <el-input
              type="textarea"
              :rows="6"
              placeholder="请输入内容"
              v-model="ruleForm.sms_content"
              maxlength="500"
              show-word-limit
              style="width:450px"
            >
            </el-input>
            <div style="text-align:right;width:450px">
              <el-button
                type="primary"
                @click="importTem"
                size="mini"
              >导入模板内容</el-button>
              <el-button
                type="primary"
                @click="addVariable"
                size="mini"
              >插入变量</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: left; padding: 130px 0 20px 110px">
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="submit('ruleForm')"
            style="width: 92px"
            size="medium"
          >保 存</el-button>
          <el-button
            plain
            @click="addtem=false"
            style="width: 92px"
            size="medium"
          >取 消</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 导入模板 -->
    <el-dialog
      title="导入模板内容"
      :visible.sync="temdata"
      width="700px"
      :close-on-click-modal="false"
    >
      <div style="padding:20px">
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="temData"
            tooltip-effect="dark"
            style="width: 100%; "
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column width="50">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="value=>{return changeCheck(value,scope.row)}"
                ></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              label="模板名称"
              prop="sms_title"
              width="200"
            ></el-table-column>
            <el-table-column
              label="模板内容"
              prop="sms_content"
            >
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="temSizeChange"
            @current-change="temCurrentChange"
            :current-page="temPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="temSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="temNum"
            style="margin:20px 0 30px"
          ></el-pagination>
        </div>
        <div style="text-align: center">
          <span
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              type="primary"
              @click="importContent"
              style="width: 92px"
              size="medium"
            >确定</el-button>
            <el-button
              plain
              @click="temdata=false"
              style="width: 92px"
              size="medium"
            >取 消</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      content: '',
      status: '',
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      addtem: false,
      ruleForm: {
        sms_title: '',
        sms_content: ''
      },
      rules: {
        sms_title: [
          { required: true, message: '请输入模板名称', trigger: 'blur' }
        ],
        sms_content: [
          { required: true, message: '请输入短信内容', trigger: 'blur' }
        ]
      },
      temData: [],
      temPage: 1,
      temSize: 10,
      temNum: 0,
      temdata: false,
      a: 0,
      checkContent: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        content: this.content,
        page: this.currentPage,
        pageNumber: this.pagesize
      };
      this.axios
        .post('platform/patient/platformSmsTaskTcmList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //添加按钮
    AddTem() {
      this.ruleForm = {
        sms_title: '',
        sms_content: ''
      };
      this.addtem = true;
    },
    //编辑按钮
    editTem(row) {
      this.ruleForm = {
        tcm_id: row.tcm_id,
        sms_title: row.sms_title,
        sms_content: row.sms_content
      };
      this.addtem = true;
    },
    //插入变量
    addVariable() {
      var regex = new RegExp(/\$\{.+?\}/, 'g');
      var result = this.ruleForm.sms_content.match(regex);
      if (result && result.length >= 5) {
        this.$message.error('最多可插入5个变量');
        return false;
      }
      this.ruleForm.sms_content = this.ruleForm.sms_content + '${ }';
    },
    //添加
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var regex = new RegExp(/\$\{.+?\}/, 'g');
          var result = this.ruleForm.sms_content.match(regex);
          if (result && result.length > 5) {
            this.$message.error('最多可插入5个变量');
            return false;
          }
          let data = {
            sms_title: this.ruleForm.sms_title,
            sms_content: this.ruleForm.sms_content.replace(/[ ]/g, '')
          };
          let url = 'platform/patient/createPlatformSmsTaskTcm';
          if (this.ruleForm.tcm_id) {
            data.tcm_id = this.ruleForm.tcm_id;
            url = 'platform/patient/updatePlatformSmsTaskTcm';
          }
          this.axios.post(url, data).then((res) => {
            if (res.code == 0) {
              this.$message.success('保存成功');
              this.addtem = false;
              this.getList();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    delTem(tcm_id) {
      this.$confirm('是否确定删除短信模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/patient/delPlatformSmsTaskTcm', { tcm_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('短信模板已删除');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    },
    //导入模板
    importTem() {
      this.getTemData();
      this.temdata = true;
    },
    //获取导入模板列表
    getTemData() {
      let data = {
        page: this.temPage,
        pageNumber: this.temSize
      };
      this.axios
        .post('platform/patient/platformSmsTaskTcmList', data)
        .then((res) => {
          if (res.code == 0) {
            this.temData = res.data.list.map((item) => {
              item.check = false;
              return item;
            });
            this.temNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    temSizeChange(size) {
      this.temSize = size;
      this.getTemData();
    },
    //当前第几页
    temCurrentChange(currentPage) {
      this.temPage = currentPage;
      this.getTemData();
    },
    changeCheck(value, row) {
      if (value) {
        this.temData.forEach((item) => {
          item.check = false;
        });
        row.check = true;
        this.checkContent = row.sms_content;
      }
    },
    importContent() {
      if (this.ruleForm.sms_content) {
        this.ruleForm.sms_content += this.checkContent;
      } else {
        this.ruleForm.sms_content = this.checkContent;
      }
      this.temdata = false;
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
  text-align: left;
}
</style>